/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CompanyTimelinesResponseData,
  CompanyTimelinesResponseDataFromJSON,
  CompanyTimelinesResponseDataFromJSONTyped,
  CompanyTimelinesResponseDataToJSON
} from './CompanyTimelinesResponseData'

/**
 *
 * @export
 * @interface CompanyTimelinesResponse
 */
export interface CompanyTimelinesResponse {
  /**
   *
   * @type {number}
   * @memberof CompanyTimelinesResponse
   */
  status?: number
  /**
   *
   * @type {CompanyTimelinesResponseData}
   * @memberof CompanyTimelinesResponse
   */
  data?: CompanyTimelinesResponseData
}

export function CompanyTimelinesResponseFromJSON(json: any): CompanyTimelinesResponse {
  return CompanyTimelinesResponseFromJSONTyped(json, false)
}

export function CompanyTimelinesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyTimelinesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CompanyTimelinesResponseDataFromJSON(json['data'])
  }
}

export function CompanyTimelinesResponseToJSON(value?: CompanyTimelinesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CompanyTimelinesResponseDataToJSON(value.data)
  }
}
